import React, { FC, useEffect } from 'react';

import { Accordion } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import {
  VulnerabilityContainerInfo,
  VulnerabilityPackageSummary,
  VulnerabilityType,
} from 'services/Vulnerability/types';

import { VulnerabilitySummaryCard } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/ResourceMetadata/Vulnerability/VulnerabilitySummaryCard';
import { selectActiveResource } from 'containers/ActiveCloudResource/selectors';
import { actions } from 'containers/ActiveCloudResource/slice';

interface Props {
  row: VulnerabilityContainerInfo;
  isExpanded: boolean;
}

export const InstanceSummaryByID: FC<Props> = props => {
  const { row, isExpanded } = props;
  const { instanceSummaryByID } = useSelector(selectActiveResource);
  const dispatch = useDispatch();

  useEffect(() => {
    isExpanded &&
      dispatch(
        actions.getInstanceSummary({
          q: {
            instanceId: row?.instance_id ?? '',
            containerId: row?.container_id,
          },
        }),
      );
  }, [dispatch, row, isExpanded]);

  return (
    <Accordion allowMultiple>
      <VulnerabilitySummaryCard
        type={VulnerabilityType.Os}
        summary={
          (row?.container_id
            ? instanceSummaryByID.data?.[row?.container_id]?.os_vulnerability
            : {}) as VulnerabilityPackageSummary
        }
        containerId={row?.container_id!}
        instanceId={row?.instance_id ?? ''}
      />
      <VulnerabilitySummaryCard
        type={VulnerabilityType.Library}
        summary={
          (row?.container_id
            ? instanceSummaryByID.data?.[row?.container_id]
                ?.library_vulnerability
            : {}) as VulnerabilityPackageSummary
        }
        containerId={row?.container_id!}
        instanceId={row?.instance_id ?? ''}
      />
    </Accordion>
  );
};
